<template>
  <div class="tabs_content">
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
        >
          <p><translate class="translate">Poskytovatel videa</translate>:<br/> <a @click="onProviderNameClick">{{ entity.vod_provider_name }}</a></p>
          <p>
            <translate class="translate">Zdroj</translate>:<br/><a @click="goToOrigin(entity.origin_url)" v-translate>Zdrojový balíček</a></p>
        </detail-entity-info>
      </div>
      <div class="right">
        <div class="field_left">
          <text-input id="vodpackagename"
                      :required="true"
                      v-model="entity.name"
                      :disabled="true"
                      ref="nameref"
          >
            <translate class="translate">Název</translate>
          </text-input>
          <date-picker id="vodpackageprovidedfrom"
                       v-model="entity.provided_from"
                       :disabled="true"
                       ref="providedfromref"

          >
            <translate class="translate">Poskytováno od</translate>
          </date-picker>
          <text-input id="vodpackagetype"
                      :required="true"
                      v-model="entity.type"
                      :disabled="true"
                      ref="typeref"
          >
            <translate class="translate">Typ balíčku</translate>
          </text-input>
        </div>
        <div class="field_right">
          <text-input id="vodpackagemaximumnumberofvideos"
                      :required="true"
                      v-model="entity.maximum_number_of_videos"
                      :disabled="true"
                      ref="maximumnumberofvideosref"
          >
            <translate class="translate">Maximální počet videí</translate>
          </text-input>
          <date-picker id="vodpackageprovidedto"
                       v-model="entity.provided_to"
                       :disabled="true"
                       ref="providedtoref"
          >
            <translate class="translate">Poskytováno do</translate>
          </date-picker>
          <checkbox-input id="vodpackageoperatoreditable"
                          :required="true"
                          v-model="entity.operator_editable"
                          :disabled="true"
                          ref="operatoreditableref"
          >
            <translate class="translate">Editovatelné operátorem</translate>
          </checkbox-input>
          <checkbox-input id="vodpackageactive"
                          :required="true"
                          v-model="entity.active"
                          :disabled="true"
                          ref="activeref"
          >
            <translate class="translate">Aktivní</translate>
          </checkbox-input>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import date from "../../../mixins/global/date";

export default {
  name: "Settings",
  components: {DetailEntityInfo},
  mixins: [date],
  props: {
    entity: Object
  },
  methods: {
    onProviderNameClick(){
      this.$router.push({name: 'vodProvidersDetail', params: {id: this.entity.id_vod_provider}})
    },
    goToOrigin(url) {
      window.open(url, '_blank');
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/views/vodPackages/detail/Settings.vue